import "./App.css";

function App() {
  return (
    <main className="dashboard">
      <h1>AwesomeProject AI Operations Center</h1>
      <p className="label">Static deployment</p>
      <section className="card" aria-live="polite">
        <h2>Runtime connectivity disabled</h2>
        <p>
          This public site is an offline status page. It does not connect to a
          runtime, broker, order system, fill service, or live-capital account.
        </p>
        <p className="warning">
          No operational state is displayed or controlled from this deployment.
        </p>
      </section>
    </main>
  );
}

export default App;
